import { render } from "./HorseTable.vue?vue&type=template&id=68ef9aa4"
import script from "./HorseTable.vue?vue&type=script&lang=js"
export * from "./HorseTable.vue?vue&type=script&lang=js"

import "./HorseTable.vue?vue&type=style&index=0&id=68ef9aa4&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__